import { axios } from "@/plugins/axios"
import store from "@/store"
import { app } from "@/main"


export async function getCameras() {
  const cameraApi = "/v1/cameras";
  let cameras = []

  await axios
    .get(cameraApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("cameraNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.cameras != undefined) {
        cameras = response.data.cameras
      }
    })

  return cameras
}

export async function getSnapshot(camera_id) {
  const snapshotApi = "/v1/snapshot?cameraId=" + camera_id;
  let snapshot = { data: null, size: {} }

  await axios
    .get(snapshotApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("cameraNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.data != undefined) {
        snapshot.data = "data:image/jpeg;base64," + response.data.data
        snapshot.size.x = response.data.size.x
        snapshot.size.y = response.data.size.y
      }
    })

  return snapshot
}

export async function getStream(camera_id) {
  const streamApi = "/v1/stream?cameraId=" + camera_id;
  let stream = null

  await axios
    .get(streamApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("cameraNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data != undefined) {
        stream = response.data
      }
    })

  return stream
}